import axios from './configAxios';

export const putEntries = async (terminal_pk, order_pk, requestData) => {
	return await axios.put(`/${terminal_pk}/${order_pk}/`, requestData);
};
